import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoggedUser} from "../../../common/logged-user.service";
import {SharedService} from "../../../services/shared.service";
import {EntityEmail, EntityType} from "../../../model/entity-email";
import {CommonMessagesService} from "../../../services/common-messages.service";
import {translate} from "@ngneat/transloco";
import {MessageService} from "primeng/api";
import {SharedPersistRequest} from "../../../model/requests/shared-persist-request";
import {SharedResource} from "../../../model/shared-resource";

@Component({
  selector: 'app-share-entity-dialog',
  templateUrl: './share-entity-dialog.component.html',
  styleUrls: ['./share-entity-dialog.component.scss']
})
export class ShareEntityDialogComponent implements OnInit {

  @Input() dialogVisible: boolean;
  @Input() sharedResources: Array<SharedResource>;
  @Output() dialogVisibleChange = new EventEmitter<boolean>();
  @Output() sharedResourceChange = new EventEmitter<boolean>();

  public loadingSharedEmails: boolean;
  public emailSuggestions: EntityEmail[];
  public persistingChanges: boolean;
  public emailsToShare: Array<EntityEmail>;
  public sharedWithEmails: Array<EntityEmail>;
  public loadingUserEmail: boolean;

  private selectedEmails: Map<string, Set<EntityType>>;
  private emailPattern: RegExp;
  public maxSharedEmails: number = 5;

  constructor(public loggedUser: LoggedUser,
              private sharedService: SharedService,
              private commonMessagesService: CommonMessagesService,
              private messageService: MessageService) {
    this.loadingSharedEmails = true;
    this.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }

  ngOnInit(): void {
  }

  public search(event) {
    this.sharedService.getEmailSuggestions(event.query).subscribe(response => {
      let suggestions = response.entityEmails;
      this.emailSuggestions = suggestions.filter(entityEmail => {
        if(this.selectedEmails.has(entityEmail.email)) {
          if(this.selectedEmails.get(entityEmail.email).has(entityEmail.entityType)) {
            return false;
          }
        }
        return true;
      });
    });
  }

  shareResource(): void {
    this.persistingChanges = true;
    const persistData = this.buildPersistData();
    this.sharedService.shareResource(persistData).toPromise()
      .then(response => {
        let summaryTr = translate('success.generic.changesApplied');
        let detailTr = translate('success.shared.update');
        this.messageService.add({severity: 'success', summary: summaryTr, detail: detailTr, sticky: false});
        this.persistingChanges = false;
        this.onVisibleChange(false);
        this.sharedResource(true);
      }).catch(error => {
      this.commonMessagesService.showErrorWhileSharingMessage();
      this.persistingChanges = false;
    });
  }

  private buildPersistData(): SharedPersistRequest {
    return {
      sharedResources: this.sharedResources,
      emailsToShare: this.emailsToShare,
    }
  }

  selectEmail(entityType: any): any {
    if (this.selectedEmails.has(entityType.email)) {
      this.selectedEmails.get(entityType.email).add(entityType.entityType);
    } else {
      this.selectedEmails.set(entityType.email, new Set<EntityType>([entityType.entityType]));
    }
  }

  unselectEmail(event: any): any {
    this.selectedEmails.delete(event.email);
  }

  clearList(): void {
    this.selectedEmails = new Map<string, Set<EntityType>>();
    this.emailsToShare = [];
    this.sharedWithEmails.forEach(entityEmail => {
      this.selectEmail(entityEmail);
    });
  }

  onVisibleChange(visible): void {
    this.dialogVisibleChange.emit(visible);
  }

  sharedResource(shared): void {
    this.sharedResourceChange.emit(shared);
  }

  openDialog(): void {
    this.emailsToShare = new Array<EntityEmail>();
    this.selectedEmails = new Map<string, Set<EntityType>>();
    this.loadSharedWithEmails();
  }

  loadSharedWithEmails(): void {
    this.loadingSharedEmails = true;
    this.loadingUserEmail = true;
    let sharedResourcesUuids = [];
    this.sharedResources.forEach(resource => {
      sharedResourcesUuids.push(resource.sharedResourceUuid);
    });
    this.loggedUser.userObservable.subscribe(user => {
      this.loadingUserEmail = false;
      if (user.email) {
        this.selectEmail({email: user.email, entityType: "USER"});
      }
    });
    this.sharedService.getEmailsForSharedResources(sharedResourcesUuids).subscribe(response => {
      this.sharedWithEmails = response.entityEmails;
      this.sharedWithEmails.forEach(entityEmail => {
        this.selectEmail(entityEmail);
      });
      this.loadingSharedEmails = false;
    });
  }
}
